import { lamportsToUiAmount, bsMath } from "@bridgesplit/utils";
import { DEFAULT_SLIPPAGE } from "app/components/common";

import { BaseWinder } from "./BaseWinder";
import { LoopWinder, LoopWinderCtx } from "./types";

export class PrincipalWinder extends BaseWinder implements LoopWinder {
    public readonly name = "PrincipalWinder";

    getCollateralInputAmountForQuote(ctx: LoopWinderCtx) {
        const { loopExpanded, principalWindExternalQuote } = ctx;
        if (!principalWindExternalQuote || !loopExpanded) return undefined;
        const minCollateralAmount = principalWindExternalQuote.minOutputAmount;
        const minCollateralAmountUi = lamportsToUiAmount(minCollateralAmount, loopExpanded.collateralToken.decimals);
        return minCollateralAmountUi;
    }

    getLeveragedCollateralAmountToDeposit(ctx: LoopWinderCtx): number | undefined {
        const { loopExpanded, externalQuote, form } = ctx;
        if (!loopExpanded || !externalQuote || !form?.inputAmount || !form?.multiplier) return undefined;

        if (externalQuote.minOutputAmount === 0) {
            return form.inputAmount * (form.multiplier - (form.percentSlippageDecimals ?? DEFAULT_SLIPPAGE));
        }

        return lamportsToUiAmount(externalQuote.minOutputAmount, loopExpanded.collateralToken.decimals);
    }

    getCollateralInputAmount(ctx: LoopWinderCtx): number | undefined {
        // so we want to use oracle pricing here because we use this value in determining the fair market value of the collateral
        const { loopExpanded, inputAmount } = ctx;
        const principalInputInCollateral = bsMath.div(
            bsMath.mul(inputAmount, loopExpanded?.principalOracle.usdPrice),
            loopExpanded?.collateralOracle?.usdPrice
        );
        return principalInputInCollateral;
    }

    calculateMarketCollateralAmounts(ctx: LoopWinderCtx) {
        const { loopExpanded, externalQuote } = ctx;

        const collateralMinOutputAmount = externalQuote?.minOutputAmount;
        const collateralOutputMintMetadata = loopExpanded?.collateralToken;

        const swappedMinOutputCollateralAmount = lamportsToUiAmount(
            collateralMinOutputAmount,
            collateralOutputMintMetadata?.decimals
        );

        // do not add collateral input to a full principal wind
        return {
            totalMinOutputCollateralAmount: swappedMinOutputCollateralAmount,
            swappedMinOutputCollateralAmount
        };
    }
}
